import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Phone, Menu, X } from 'lucide-react';
import { Monogram } from './Monogram';
const navLinks = [{
  label: 'Inicio',
  href: '#inicio'
}, {
  label: 'Servicios',
  href: '#servicios'
}, {
  label: 'Testimonios',
  href: '#testimonios'
}, {
  label: 'Inscripción',
  href: '#inscripcion'
}, {
  label: 'Preguntas',
  href: '#faq'
}, {
  label: 'Contacto',
  href: '#contacto'
}];
export function Header() {
  const [open, setOpen] = useState(false);
  const handleNavClick = (href: string) => {
    setOpen(false);
    setTimeout(() => {
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }, 100);
  };
  return <>
      <header className="fixed top-0 left-0 right-0 z-50 bg-navy text-white shadow-md border-b border-gold/20" data-id="element-134">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between" data-id="element-135">
          <a href="#inicio" className="flex items-center gap-3" onClick={e => {
          e.preventDefault();
          handleNavClick('#inicio');
        }} data-id="element-136">
            <Monogram size={44} className="shrink-0" data-id="element-137" />
            <div className="flex flex-col" data-id="element-138">
              <span className="font-serif font-semibold text-sm md:text-base text-gold" data-id="element-139">
                Anisley Estanque
              </span>
              <span className="text-xs text-white/80 tracking-wide uppercase hidden sm:block" data-id="element-140">
                Agente Licenciada
              </span>
            </div>
          </a>

          {/* Desktop nav */}
          <nav className="hidden lg:flex items-center gap-6" data-id="element-141">
            {navLinks.map(link => <a key={link.href} href={link.href} onClick={e => {
            e.preventDefault();
            handleNavClick(link.href);
          }} className="text-sm text-white/85 hover:text-gold transition-colors font-medium" data-id="element-142">
                {link.label}
              </a>)}
          </nav>

          <div className="flex items-center gap-2 md:gap-3" data-id="element-143">
            <a href="tel:786-374-5660" className="flex items-center gap-2 bg-gold hover:bg-gold-light text-navy px-3 md:px-4 py-2 rounded-full font-medium transition-colors text-sm md:text-base" data-id="element-144">
              <Phone className="w-4 h-4" data-id="element-145" />
              <span className="hidden sm:inline" data-id="element-146">786-374-5660</span>
              <span className="sm:hidden" data-id="element-147">Llamar</span>
            </a>

            <button onClick={() => setOpen(!open)} className="lg:hidden p-2 rounded-md hover:bg-white/10 transition-colors" aria-label="Abrir menú" aria-expanded={open} data-id="element-148">
              {open ? <X className="w-6 h-6 text-gold" data-id="element-149" /> : <Menu className="w-6 h-6 text-gold" data-id="element-150" />}
            </button>
          </div>
        </div>

        {/* Mobile accordion menu */}
        <AnimatePresence data-id="element-151">
          {open && <motion.nav initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.3,
          ease: 'easeInOut'
        }} className="lg:hidden bg-navy-light border-t border-gold/20 overflow-hidden" data-id="element-152">
              <ul className="flex flex-col py-2" data-id="element-153">
                {navLinks.map((link, idx) => <motion.li key={link.href} initial={{
              opacity: 0,
              x: -10
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: idx * 0.05
            }} data-id="element-154">
                    <a href={link.href} onClick={e => {
                e.preventDefault();
                handleNavClick(link.href);
              }} className="block px-6 py-3 text-white/90 hover:bg-navy hover:text-gold transition-colors border-l-2 border-transparent hover:border-gold font-medium" data-id="element-155">
                      {link.label}
                    </a>
                  </motion.li>)}
              </ul>
            </motion.nav>}
        </AnimatePresence>
      </header>
    </>;
}